import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, catchError, retry, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MenuItem } from '../../models/menu-item';
import { Router } from '@angular/router';
import { MeUser } from '../../models/me-user';
import { customerJourneyMenu, defaultMenu, dashboardMenu } from './models/default-pages';
import {MatomoService} from "../matomo.service";
import {NavState} from "../../../store/navigation/navigation.reducer";
import * as NavActions from "../../../store/navigation/navigation.action";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/app.state";
import {touchpoint} from "../../../store/navigation/navigation.action";



@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  _availableStepsSubject: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([]);
  _selectedStepSubject: BehaviorSubject<MenuItem | null> = new BehaviorSubject<MenuItem | null>(null);
  _selectedPageSubject: BehaviorSubject<MenuItem | null> = new BehaviorSubject<MenuItem | null>(null);
  defaultStep: MenuItem = defaultMenu();
  currentUser: MeUser | null = null;

  constructor(private http: HttpClient,
    private router: Router, private store: Store<NavState>) {

    /*this._selectedPageSubject.subscribe(step => {
      //this.store.dispatch(NavActions.leftMenu({ item: step?.route?.replace(/[^a-zA-Z0-9]/g, '')?? ''}));
      this.store.dispatch(NavActions.leftMenu({ item: step?.idItem ?? ''}));
    })*/

    /*this._selectedStepSubject.subscribe(step => {
      const stepName = step?.idItem ?? step?.name;
      this.store.dispatch(touchpoint({ item: stepName ?? ''}));
    })*/

  }

  startNavbarMenu(user: MeUser) {
    this.getNavBar().subscribe(response => {
      this.defaultStep = defaultMenu(user.scope, user?.roles ?? []);
      this.selectStep(this.defaultStep);
      this._availableStepsSubject.next(response);
    })
  }

  private getNavBar(): Observable<MenuItem[]> {
    return this.http.get<MenuItem[]>(`${environment.csibefrontend}listMenu`).pipe(
      catchError((error: Response) => {
        console.log(error);
        throw JSON.stringify({ success: false, status: error.status });
      })
    );
  }

  selectStep(step: MenuItem) {
    //this.matomoService.trackEvent('Navigation', 'Navigate', step.name);
    //this.matomoService.trackPageViewByMenuItem(step);
    this._selectedStepSubject.next(step);
  }

  deselectStep() {
    this._selectedStepSubject.next(this.defaultStep);
  }

  selectPage(item: MenuItem) {
    if (item.route) {

      //this.matomoService.trackEvent('Navigation', 'Navigate', item.route);

      if (item.name == 'DASHBOARD') {
        this.selectStep(this.defaultStep)


      }

      this.router.navigateByUrl(item.route);
      this._selectedPageSubject.next(item);
    }
  }

  navigateToLandingPage(scope: string) {
    this.defaultStep = defaultMenu(scope, this.currentUser?.roles ?? []);
    this.selectStep(this.defaultStep)
    this.selectPage(this.defaultStep.menuScope[0].children[0])
  }
}
